<template>
  <div class="import">
    <import />
  </div>
</template>

<script>
import Import from "@/components/Import";

export default {
  name: "ImportView",
  components: {
    Import,
  },
  metaInfo() {
    return {
      title: "Cuéntanos lo que buscas " + process.env.VUE_APP_META_TITLE,
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Cuéntanos que estas buscando y nos pondremos en contacto para ofrecerte la mejor selección de pisos, casas, locales, oficinas y fincas de Pontevedra"
        }
      ],
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_LINK + this.$route.path
        }
      ]
    };
  }
};
</script>
